// Links students send to friends: "Share Re:Vault" and Study Hall room invites.
//
// Always the main site, https://endis.rest: one address everyone recognizes. Never a custom
// domain, another copy of Re:Vault, or a list of addresses. A local test server shares itself so
// the checks can follow the link. The `s` parameter only says how someone arrived ("share" or
// "invite"); the visitor counter adds it to the day's totals and the app drops it from the address.
// No ids, nothing about who shared.
export const SHARE_ORIGIN = "https://endis.rest";
export const SHARE_TITLE = "Share Re:Vault";
export const SHARE_TEXT = "Studying with friends is better. Send them Re:Vault.";
// What a share sheet or a chat app shows next to the link.
export const SHARE_MESSAGE = "I study with Re:Vault: books, study tools and focus rooms in one place.";

const LOCAL = /^(?:localhost|127(?:\.\d{1,3}){3}|\[::1\]|(?:[a-z0-9-]+\.)+localhost)$/i;

export function shareOrigin(loc) {
	try { if (loc && LOCAL.test(String(loc.hostname)) && /^https?:$/.test(loc.protocol)) return loc.origin; } catch { /* fall through */ }
	return SHARE_ORIGIN;
}
export const shareUrl = (loc) => shareOrigin(loc) + "/?s=share";

// Invite codes: 10 characters, no 0/O/1/I so they survive being read out loud.
export const INVITE_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
export const INVITE_RE = /^[A-HJ-NP-Z2-9]{10}$/;
// The code rides in the #fragment, which browsers never send to a server, so it stays out of
// access logs (a log line with the code and an address could be matched to whoever made it).
export const inviteUrl = (loc, code) => shareOrigin(loc) + "/?s=invite#invite=" + code;

// A code from an address (#invite=CODE), upper-cased; "" when there is none or it's malformed.
export function inviteFrom(hash) {
	const m = /^#invite=([^&]*)$/i.exec(String(hash || ""));
	const v = m ? m[1].trim().toUpperCase() : "";
	return INVITE_RE.test(v) ? v : "";
}

// The address without the arrival parameters, for history.replaceState.
export function withoutArrival(loc) {
	let q;
	try { q = new URLSearchParams(loc.search); } catch { return loc.pathname; }
	q.delete("s");
	const s = q.toString();
	return loc.pathname + (s ? "?" + s : "") + (/^#invite=/i.test(loc.hash || "") ? "" : loc.hash);
}
